module.exports = __webpack_public_path__ + "static/planwell_green-8bf6e704272e9e439e6fc490baa06d18.svg";